import {AfterViewInit, Component, EventEmitter, Inject, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {UsersTabSearchComponent} from '../../users-tab/users-tab-search/users-tab-search.component';
import {SearchTermDefinitionInf} from '../../../interfaces/common/search/search-term-definition-inf';
import {DisplayedColumnInf} from '../../../interfaces/common/table/displayed-column-inf';
import {AttributesApiService} from '../../../services/api/users/attributes/attributes-api.service';
import * as _ from 'lodash';
import {GroupsApiService} from '../../../services/api/users/groups/groups-api.service';
import {PageEventCursorInf} from '../../../classes/common/table/page-event-cursor';
import {ArmTableComponent} from '../../../components/arm-table/arm-table.component';
import {LoaderService} from '../../../services/common/loader-service/loader.service';
import {DIALOG_CONFIG} from 'ac-infra';
import {NgForm} from '@angular/forms';

export interface UserGroupDialogInf {
  selectedItem: any;
  isEditMode?: boolean;
  attributes;
  dialableAttributes;
  associatedDialable;
  originOptions;
}

@Component({
  selector: 'user-groups-dialog',
  templateUrl: './user-groups-dialog.component.html',
  styleUrls: ['./user-groups-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UserGroupsDialogComponent implements OnInit, AfterViewInit {

  @ViewChild(ArmTableComponent) armTable;
  @ViewChild('mapForm') mapForm: NgForm;
  dialogConf;
  nextInternalId: number;
  attributes: any[];
  usersSearchComponent = UsersTabSearchComponent;
  tableData;
  search: any = {};
  dataLoaded = false;
  allData;

  pageEventCursor: PageEventCursorInf = {
    before: null,
    after: null,
    pageSize: 25
  };

  searchData = {};

  searchTerms: SearchTermDefinitionInf[] = [
    {term: 'name', operator: ':', displayName: 'Name'},
    {term: 'origin', operator: '=', displayName: 'Origin'}
  ];

  readonly separatorKeysCodes: number[] = [ENTER, COMMA];

  operatorsOptions = [
    { id: 'EQUALS', name: 'Equals' },
    { id: 'NOT_EQUALS', name: 'Not Equals' },
    { id: 'CONTAINS', name: 'Contains' },
    { id: 'NOT_CONTAINS', name: 'Not Contains' }
  ];

  displayedColumns: Array<DisplayedColumnInf> = [];

  constructor(private attributesApiService: AttributesApiService,
              private groupsApiService: GroupsApiService,
              @Inject(DIALOG_CONFIG) private dialogConfig ) {
      this.allData = dialogConfig.dialogData;
      this.dialogConf = dialogConfig;
  }


  ngOnInit(): void {
    this.searchData = {
      originOptions: this.allData.originOptions
    };

    this.refresh();
  }

  refresh(): void {
    this.attributesApiService.getUserDisplayAttributes().then((data) => {
      this.displayedColumns = data;
    }).catch(err => {
      console.log(`Exception was thrown in refresh ${err}`);
    });
  }



  onOutOfFocus(event, values): void {
    if (!!(event.target.value).trim()) {
      this.addValue(event.target, values);
    } else if ((event.target.value).trim() === '' && values.length === 0) {
      this.addValue(event.target, values);
    }

    event.target.value = '';
    this.checkIsFormValid();
  }

  addValue(event, values): void {
    const value = event.value;
    const input = event.input;

    if ((value).trim() === '' && !values.includes('')) {
      values.push(value.trim());
    } else if (!!(value).trim()) {
      values.push(value.trim());
    }

    if (input && input.value) {
      input.value = '';
    }
    event.value = '';

  }

  addCondition(): void {
    this.allData.selectedItem.conditions.push({
      internalId: this.nextInternalId,
      dicAttrName: this.allData.attributes.length > 0 ? this.allData.attributes[0].name : null,
      operator: 'EQUALS',
      values: []
    });
    this.nextInternalId++;
    this.checkIsFormValid();
  }

  removeCondition(index): void {
    this.allData.selectedItem.conditions.splice(index, 1);
    if (this.allData.selectedItem.conditions.length === 0) {
      this.checkIsFormValid();
    }
  }

  refreshUsersTable(): void {
    let params = {
      limit: this.pageEventCursor.pageSize,
      cursor: _.isNil(this.pageEventCursor.after) ? null : this.pageEventCursor
    };

    params = {...this.search, ...params};
    this.dataLoaded = false;
    this.groupsApiService.getGroupDryRun(this.allData.selectedItem, params).then(data => {
      this.tableData = data.users;
      this.pageEventCursor.before = data.cursor.before;
      this.pageEventCursor.after = data.cursor.after;
      this.dataLoaded = true;
    }).catch(() => {
      this.dataLoaded = true;
    });
  }

  onSelectedTabChange(event): void {
    if (event.tab && event.tab.textLabel === 'USERS') {
      this.refreshUsersTable();
    }
  }

  pageChanged(event: PageEventCursorInf): void {
    this.pageEventCursor = event;
    this.refreshUsersTable();
  }

  onSearch(data): void {
    this.armTable.firstPage();
    this.search = data;

    this.refreshUsersTable();
  }

  ngAfterViewInit(): void {
    this.mapForm.form.statusChanges.subscribe(() => {
      this.checkIsFormValid();
    });
  }

  checkIsFormValid(): void {
    this.dialogConf.submitButtonDisabled = !this.mapForm.form.valid || this.allData.selectedItem.conditions.length === 0;
  }



}
